__webpack_require__.p = "/static/generated-collector/";